export const PING_RETRY_MINUTES = 1;